import React, { createContext, useContext } from 'react';
import { ServiceCalculatorContextProps, ServiceCalculatorProviderProps } from './ServiceCalculatorContext.types';
import { useServiceCalculatorLogic } from './useServiceCalculatorLogic';

const ServiceCalculatorContext = createContext<ServiceCalculatorContextProps | undefined>(undefined);

const ServiceCalculatorProvider = ({ children }: ServiceCalculatorProviderProps) => (
  <ServiceCalculatorContext.Provider value={useServiceCalculatorLogic()}>{children}</ServiceCalculatorContext.Provider>
);

export default ServiceCalculatorProvider;

export const useServiceCalculator = () => {
  const context = useContext(ServiceCalculatorContext);
  if (!context) throw new Error('useServiceCalculator must be used within a ServiceCalculatorProvider');
  return context;
};
